module.exports = __webpack_public_path__ + "static/media/logo_spinner.5ef4f404.png";